const initialState = {
  data : {
    sudoSites: [],
    pagination: {
      count: 0,
      pageCount: 1,
    },
  },
  filterOptions: [],
  loadingCompanyFilterOptions: null,
  pageSize: 20,
  loadingCompany: null,
};

export default function company(state = initialState, action) {
  switch (action.type) {

    case "LOAD_COMPANY_FILTER_OPTIONS_START":
      return {
        ...state,
        loadingCompanyFilterOptions: true,
      };

    case "LOAD_COMPANY_FILTER_OPTIONS_SUCCESS":
      return {
        ...state,
        filterOptions: action.data ? action.data : [],
        loadingCompanyFilterOptions: false,
      }

    case "LOAD_COMPANY_FILTER_OPTIONS_FAILED":
      return {
        ...state,
        loadingCompanyFilterOptions: false,
      };

    case "LOAD_COMPANY_FILTER_OPTIONS_CANCEL":
      return {
        ...state,
        loadingCompanyFilterOptions: false,
      };

    case "LOAD_COMPANY_START":
      return {
        ...state,
        loadingCompany: true,
      };

    case "LOAD_COMPANY_SUCCESS":
      return {
        ...state,
        data: action.data ? action.data : {
          sudoSites: [],
          pagination: {
            count: 0,
            pageCount: 1,
          },
        },
        pageSize: action.startAction.pageSize || 20, // keep a record of the page size - it's needed when applying the external filters
        loadingCompany: false,
      }

    case "LOAD_COMPANY_FAILED":
      return {
        ...state,
        loadingCompany: false,
      };

    case "LOAD_COMPANY_CANCEL":
      return {
        ...state,
        loadingCompany: false,
      };

    case "CLEAR_COMPANY":
      return {
        ...state,
        data : {
          sudoSites: [],
          pagination: {
            count: 0,
            pageCount: 1,
          },
        },
        filterOptions: [],
        loadingCompanyFilterOptions: null,
        pageSize: 20,
        loadingCompany: null,
      };

    case "SET_COMPANY_PAGE_SIZE":
      return {
        ...state,
        pageSize: action.pageSize,
        displayPageIndex: action.displayPageIndex,
      };

    default:
      return state;
  }
}